import { render, staticRenderFns } from "./M2hChallengesWidget.vue?vue&type=template&id=4daa5809&scoped=true&"
import script from "./M2hChallengesWidget.vue?vue&type=script&lang=js&"
export * from "./M2hChallengesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa5809",
  null
  
)

export default component.exports